import React from 'react'
import { Box, Button, Text } from '@usap/uicomponents'
import { Heading2 } from '../../common/heading'
import getConfig from '@usap/carparts/src/config/getConfig'

const config=getConfig()
const specialPhoneNumber=config?.common?.carbTextIndexIndicator?.specialPhoneNumber
const CancelReturn = ({ onCancelReturn, setDisplayCancel }) => (
  <Box
    fadeIn
    style={{
      padding: 16,
      width: '330px',
      backgroundColor: '#FFF',
    }}
  >
    <Heading2
      style={{ fontSize: '20px' }}
      title="Confirm Return Cancellation"
    />
    <Text
     size="small"
      style={{
       display: 'flex',
       flexDirection:'column',
       gap: '20px',
       marginBottom:"15px"
      }}>
      <span>Are you sure you want to cancel your return? All your information will not saved.</span>
      <span> Need help? Contact our customer service team at {specialPhoneNumber}</span>
    </Text>
    <Box direction="row" align="center" justify="evenly">
      <Text
        size="small"
        style={{ color: '#05629B', cursor: 'pointer' }}
        onClick={() => setDisplayCancel(false)}
      >
        Continue Return
      </Text>
      <Button
        onClick={() => onCancelReturn()}
        type="submit"
        style={{ fontSize: 14, color: '#DB2429', fontWeight: 'bold' }}
        color="#DB2429"
        hideBorder
        size="small"
        label="Cancel Return"
      />
    </Box>
  </Box>
)

export default CancelReturn
